module.exports = __webpack_public_path__ + "media/content-creator/mobile-beauty-3-1d4e9f44.png";